import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
// import HomeAbout from '../components/About/HomeAbout.jsx';

// import AboutFive from '../container/About/AboutFive';
// import TestimonialContainer from '../container/Testimonial/TestimonialContainer';
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
import EmptyTwo from "../container/Empty/EmptyTwo";
// import TableData from "../data/table/commitee.json";
// import Commitee from "../components/table/Commitee";

// import {Link} from "react-router-dom";

// import EmptyOne from '../container/Empty/EmptyOne';

// const divStyle1={
//     mso-tab-count:1

// };

// const divStyle2={
//     mso-list:"Ignore"

// };

const Committees = () => {
  return (
    <React.Fragment>
      <SEO title="Committees | DMBD 2026" />
      <Header />
      <Breadcrumb
        image="images/bg/banner2-opt.jpg"
        title="Committees"
        content="The Conference"
        contentTwo="Committees"
        linkage="/"
      />

      {/* <HomeAbout /> */}
      <EmptyTwo>
        <div className="entry-content">
          <div className="row row-content align-items-center">
            <div className="col-12">

              <h5><u>General Chair</u></h5>
              <p>Ying Tan, Peking University, Beijing, China</p>


              {/* <h5><u>Program Committee Chair</u></h5>
              <p>Yuhui Shi, Southern University of Science and Technology, Shenzhen, China</p>

              <br></br> */}

              <h5><u>Program Committee Co-chair</u></h5>

              <p>Yuhui Shi, Southern University of Science and Technology, Shenzhen, China
                <br></br>
                Wenbin Zhang, Michigan Technological University, Michigan, USA
              </p>
              <h5><u>Advisory Committee Co-chairs</u></h5>
              <p>
                Xingui He, Peking University, Beijing, China
                <br></br>
                Gary G. Yen, Oklahoma State University, Oklahoma, USA
              </p>

              <h5><u>Technical Committee</u></h5>
              <p>
                Benjamin W. Wah, The Chinese University of Hong Kong, Hong Kong, China
                <br></br>
                Guoying Wang, Chongqing University of Posts and Telecommunications, Chongqing, China
                <br></br>
                Enhong Chen, University of Science and Technology of China, Hefei, China
                <br></br>
                Fernando Buarque, Universidade of Pernambuco, Recife, Brazil
                <br></br>
                Haibo He, University of Rhode Island Kingston, Rhode Island, USA
                <br></br>
                Jihong Zhu, Tsinghua University, Beijing, China
                <br></br>
                Jin Li, Guangzhou University, Guangzhou, China
                <br></br>
                Kay Chen Tan, The Hong Kong Polytechnic University, Hong Kong, China
                <br></br>
                Nikola Kasabov, Auckland University of Technology, Auckland, New Zealand
                <br></br>
                Qirong Tang, Tongji University, Shanghai, China
                <br></br>
                Yew-Soon Ong, Nanyang Technological University, Singapore
                <br></br>
                Yi Zhang, Sichuan University, Chengdu, China
              </p>

              <h5><u>Invited Speakers Session Co-chairs</u></h5>
              <p>
                Andres Iglesias, University of Cantabria, SANTANDER, Spain
                <br></br>
                Shaoqiu Zheng, The 28th Research Institute of China Electronics Technology Group
                Corporation, Nanjing, China
                <br></br>
              </p>

              <h5><u>Special Session Co-chairs</u></h5>
              <p>
                Ben Niu, Shenzhen University, Shenzhen, China
                <br></br>
                Kun Liu, Advanced Institute of Big Data, Beijing, China
                <br></br>
              </p>

              <h5><u>Publication Co-chairs</u></h5>
              <p>
                Radu-Emil Precup, Politehnica University of Timisoara, Timisoara, Romania
                <br></br>
                Weiwei Hu, Tencent Corporation, Beijing, China
                <br></br>
              </p>

              <h5><u>Publicity Co-chairs</u></h5>
              <p>
                Eugene Semenkin, Siberian Aerospace University, Krasnoyarsk, Russia
                <br></br>
                Junqi Zhang, Tongji University, Shanghai, China
                <br></br>
              </p>

              <h5><u>Finance and Registration Chairs</u></h5>
              <p>
                Andreas Janecek, University of Vienna, Vienna, Austria
                <br></br>
                Suicheng Gu, Google Corporation, San Franocisco, USA
                <br></br>
              </p>

              <h5><u>Conference Secretariat</u></h5>
              <p>
                Wenbo Yan, Peking University, Beijing, China
              </p>
            </div>
          </div>




          <br></br>
          <br></br>
          <br></br>
          <br></br>

          <h3>International Program Committee</h3>
          <br></br>
          {/* <h4>To be released.</h4> */}
          <table cellPadding={0} cellSpacing={0}>
            <colgroup>
              <col width={200} />
              <col width={200} />
              <col width={687} />
            </colgroup>
            <tbody>
              <tr height={18}>
                <td height={18} width={150}>
                  <div align="left">
                    <strong>First Name</strong>
                  </div>
                </td>
                <td width={180}>
                  <div align="left">
                    <strong>Last Name</strong>
                  </div>
                </td>
                <td width={687}>
                  <div align="left">
                    <strong>Affiliate</strong>
                  </div>
                </td>
              </tr>


              {/* <tr>
                <td className="align-middle">Min
</td>
                <td className="align-middle">Shi
</td>
                <td className="align-middle">Hunan University of Science and Technology
</td>
              </tr>

              <tr>
                <td className="align-middle">Lov
</td>
                <td className="align-middle">Kumar
</td>
                <td className="align-middle">National Institute of Technology, Kurukshetra
</td>
              </tr>
              <tr>
                <td className="align-middle">Jianhua
</td>
                <td className="align-middle">Xu
</td>
                <td className="align-middle">Nanjing Normal University
</td>
              </tr>
              <tr>
                <td className="align-middle">Seyedfakhredin
</td>
                <td className="align-middle">Musavishavazi
</td>
                <td className="align-middle">BAuA, Federal Institute for Occupational Safety and Health
</td>
              </tr>
              <tr>
                <td className="align-middle">Jinwen
</td>
                <td className="align-middle">Ma
</td>
                <td className="align-middle">Peking University
</td>
              </tr>
              <tr>
                <td className="align-middle">Xiaosong
</td>
                <td className="align-middle">Zhang
</td>
                <td className="align-middle">Tangshan University
</td>
              </tr>
              <tr>
                <td className="align-middle">Xin
</td>
                <td className="align-middle">Peng
</td>
                <td className="align-middle">Hainan University
</td>
              </tr>
              <tr>
                <td className="align-middle">Mladen
</td>
                <td className="align-middle">Veinović
</td>
                <td className="align-middle">Singidunum University
</td>
              </tr>
              <tr>
                <td className="align-middle">Ling
</td>
                <td className="align-middle">Yu
</td>
                <td className="align-middle">Jinan University
</td>
              </tr>
              <tr>
                <td className="align-middle">Jiwei
</td>
                <td className="align-middle">Zhang
</td>
                <td className="align-middle">Beijing University of Posts and Telecommunications
</td>
              </tr>
              <tr>
                <td className="align-middle">Sreeja
</td>
                <td className="align-middle">N.K
</td>
                <td className="align-middle">PSG College of Technology
</td>
              </tr>
              <tr>
                <td className="align-middle">Chengying
</td>
                <td className="align-middle">Mao
</td>
                <td className="align-middle">School of Software and IoT Engineering, Jiangxi University of Finance and Economics, 330032 Nanchang, China
</td>
              </tr>
              <tr>
                <td className="align-middle">Yuchen
</td>
                <td className="align-middle">Zhang
</td>
                <td className="align-middle">Northwest A&F University
</td>
              </tr>
              <tr>
                <td className="align-middle">Weifeng
</td>
                <td className="align-middle">Gao
</td>
                <td className="align-middle">Xidian University
</td>
              </tr>
              <tr>
                <td className="align-middle">Jiten
</td>
                <td className="align-middle">Sidhpura
</td>
                <td className="align-middle">Sardar Patel Institute of Technology
</td>
              </tr>
              <tr>
                <td className="align-middle">Ke
</td>
                <td className="align-middle">Gu
</td>
                <td className="align-middle">Changsha university of science and technology
</td>
              </tr>
              <tr>
                <td className="align-middle">Peng-Yeng
</td>
                <td className="align-middle">Yin
</td>
                <td className="align-middle">National Chi Nan University
</td>
              </tr>
              <tr>
                <td className="align-middle">Jiang
</td>
                <td className="align-middle">Zhou
</td>
                <td className="align-middle">Texas Tech University
</td>
              </tr>
              <tr>
                <td className="align-middle">Jie
</td>
                <td className="align-middle">Zhang
</td>
                <td className="align-middle">Newcastle University
</td>
              </tr>
              <tr>
                <td className="align-middle">Yi
</td>
                <td className="align-middle">Liu
</td>
                <td className="align-middle">PLA University of Science and Technology
</td>
              </tr>
              <tr>
                <td className="align-middle">Ying
</td>
                <td className="align-middle">Tan
</td>
                <td className="align-middle">Peking University
</td>
              </tr>
              <tr>
                <td className="align-middle">Khaldoon
</td>
                <td className="align-middle">Dhou
Texas A&M University Central Texas
</td>
                <td className="align-middle">Texas A&M University Central Texas
</td>
              </tr>
              <tr>
                <td className="align-middle">Shuyin
  </td>
                <td className="align-middle">Xia
</td>
                <td className="align-middle">Chongqing University of Posts and Telecommunications
</td>
              </tr>
              <tr>
                <td className="align-middle">Radu-Emil
</td>
                <td className="align-middle">Precup
</td>
                <td className="align-middle">Politehnica University of Timisoara
</td>
              </tr>
              <tr>
                <td className="align-middle">Ju
</td>
                <td className="align-middle">Liu
</td>
                <td className="align-middle">School of Information Science and Engineering, Shandong University
</td>
              </tr>
              <tr>
                <td className="align-middle">Roshni
</td>
                <td className="align-middle">Iyer
</td>
                <td className="align-middle">UCLA
</td>
              </tr>
              <tr>
                <td className="align-middle">Wenjian
</td>
                <td className="align-middle">Luo
</td>
                <td className="align-middle">Harbin Institute of Technology, Shenzhen
</td>
              </tr>
              <tr>
                <td className="align-middle">Shi
</td>
                <td className="align-middle">Cheng
</td>
                <td className="align-middle">Shaanxi Normal University
</td>
              </tr>
              <tr>
                <td className="align-middle">Ka-Chun
</td>
                <td className="align-middle">Wong
</td>
                <td className="align-middle">City University of Hong Kong
</td>
              </tr>
              <tr>
                <td className="align-middle">Eva
</td>
                <td className="align-middle">Tuba
</td>
                <td className="align-middle">University of Belgrade
</td>
              </tr>
              <tr>
                <td className="align-middle">Carmelo J. A.
</td>
                <td className="align-middle">Bastos Filho
</td>
                <td className="align-middle">University of Pernambuco
</td>
              </tr>
              <tr>
                <td className="align-middle">Hongyuan
</td>
                <td className="align-middle">Gao
</td>
                <td className="align-middle">Harbin Engineering University
</td>
              </tr>
              <tr>
                <td className="align-middle">Abdelmalek
</td>
                <td className="align-middle">Amine
</td>
                <td className="align-middle">GeCoDe Laboratory, Tahar Moulay University of Saida
</td>
              </tr>
              <tr>
                <td className="align-middle"></td>
                <td className="align-middle"></td>
                <td className="align-middle"></td>
              </tr>
              <tr>
                <td className="align-middle">Nebojsa
</td>
                <td className="align-middle">Bacanin
</td>
                <td className="align-middle">Singidunum university
</td>
              </tr>
              <tr>
                <td className="align-middle">Qingjian
</td>
                <td className="align-middle">Ni
</td>
                <td className="align-middle">Southeast University
</td>
              </tr>
              <tr>
                <td className="align-middle">Mukesh
</td>
                <td className="align-middle">Prasad
</td>
                <td className="align-middle">University of Technology, Sydney
</td>
              </tr>
              <tr>
                <td className="align-middle">Mingyan
</td>
                <td className="align-middle">Jiang
</td>
                <td className="align-middle">Shandong University
  </td>
              </tr>
              <tr>
                <td className="align-middle">Hui
</td>
                <td className="align-middle">Lu
</td>
                <td className="align-middle">Beihang University
</td>
              </tr>
              <tr>
                <td className="align-middle">Junfeng
</td>
                <td className="align-middle">Chen
</td>
                <td className="align-middle">Hohai University
</td>
              </tr>
              <tr>
                <td className="align-middle">Qunfeng
</td>
                <td className="align-middle">Liu
</td>
                <td className="align-middle">Dongguan University of Technology
</td>
              </tr>
              <tr>
                <td className="align-middle">Kun
</td>
                <td className="align-middle">Liu
</td>
                <td className="align-middle">Advanced Institute of Big Data, Beijing
</td>
              </tr>
              <tr>
                <td className="align-middle">Shenshen
</td>
                <td className="align-middle">Gu
</td>
                <td className="align-middle">Shanghai University
</td>
              </tr>
              <tr>
                <td className="align-middle">Hui
</td>
                <td className="align-middle">Zhang
</td>
                <td className="align-middle">Southwest University of Science and Technology
</td>
              </tr>
              <tr>
                <td className="align-middle">Yifei
</td>
                <td className="align-middle">Sun
</td>
                <td className="align-middle">Shaanxi Normal University
</td>
              </tr>
              <tr>
                <td className="align-middle">Yu
</td>
                <td className="align-middle">Xue
</td>
                <td className="align-middle">School of Computer and Software, Nanjing University of Information Science & Technology, Nanjing, 210044, P. R. China
</td>
              </tr>
              <tr>
                <td className="align-middle">Shaoqiu</td>
                <td className="align-middle">Zheng
</td>
                <td className="align-middle">Peking University
</td>
              </tr>

              <tr>
                <td className="align-middle">Mario
</td>
                <td className="align-middle">Pavone
</td>
                <td className="align-middle">University of Catania
</td>
              </tr>
              <tr>
                <td className="align-middle">Yan
</td>
                <td className="align-middle">Pei
</td>
                <td className="align-middle">University of Aizu
</td>
              </tr>
              <tr>
                <td className="align-middle">Colin
</td>
                <td className="align-middle">Johnson
</td>
                <td className="align-middle">University of Nottingham
</td>
              </tr>
              <tr>
                <td className="align-middle">Yuping
</td>
                <td className="align-middle">Wang
</td>
                <td className="align-middle">School of Computer Science and Technology, Xidian University, Xi&apos;an, China
</td>
              </tr>
              <tr>
                <td className="align-middle">Bei
</td>
                <td className="align-middle">Dong
</td>
                <td className="align-middle">Shaanxi Nomal University
</td>
              </tr>
              <tr>
                <td className="align-middle">Ziyu
</td>
                <td className="align-middle">Jia
</td>
                <td className="align-middle">Beijing Jiaotong University
</td>
              </tr>
              <tr>
                <td className="align-middle">Sabri
</td>
                <td className="align-middle">Arik
</td>
                <td className="align-middle">Istanbul University
</td>
              </tr>
              <tr>
                <td className="align-middle">Germano
</td>
                <td className="align-middle">Lambert-Torres
</td>
                <td className="align-middle">PS Solutions
</td>
              </tr>
              <tr>
                <td className="align-middle">Walter
</td>
                <td className="align-middle">Chen
</td>
                <td className="align-middle">Dept. of Civil Engineering, National Taipei University of Technology
</td>
              </tr>
              <tr>
                <td className="align-middle">Qiaoyong
</td>
                <td className="align-middle">Jiang
</td>
                <td className="align-middle">Xi&apos;an University of Technology
</td>
              </tr>
              <tr>
                <td className="align-middle">Liangjun
</td>
                <td className="align-middle">Ke
</td>
                <td className="align-middle">Xi&apos;an Jiaotong Univ, Systems Eng Inst, 28 W Xianning Rd
</td>
              </tr>

              <tr>
                <td className="align-middle">Jun
</td>
                <td className="align-middle">Liu
</td>
                <td className="align-middle">Carnegie Mellon University
</td>
              </tr> */}
           
<tr>
  <td className="align-middle">Aakanksha</td>
  <td className="align-middle">Joshi</td>
  <td className="align-middle"></td>
</tr>
<tr>
  <td className="align-middle">Ali J.</td>
  <td className="align-middle">Ghandour</td>
  <td className="align-middle">National Center for Remote Sensing</td>
</tr>
<tr>
  <td className="align-middle">Aravind</td>
  <td className="align-middle">Raghu</td>
  <td className="align-middle">HYR Global Source</td>
</tr>
<tr>
  <td className="align-middle">Ashish</td>
  <td className="align-middle">Kumar</td>
  <td className="align-middle">Indian Institute of Technology Roorkee</td>
</tr>
<tr>
  <td className="align-middle">Bin</td>
  <td className="align-middle">Cao</td>
  <td className="align-middle">Tsinghua University</td>
</tr>
<tr>
  <td className="align-middle">Carmelo J. A.</td>
  <td className="align-middle">Bastos Filho</td>
  <td className="align-middle">University of Pernambuco</td>
</tr>
<tr>
  <td className="align-middle">Changan</td>
  <td className="align-middle">Jiang</td>
  <td className="align-middle">Osaka Institute of Technology</td>
</tr>
<tr>
  <td className="align-middle">Changling</td>
  <td className="align-middle">Zhou</td>
  <td className="align-middle">Peking University</td>
</tr>
<tr>
  <td className="align-middle">Chenggang</td>
  <td className="align-middle">Zhang</td>
  <td className="align-middle">Tsinghua University</td>
</tr>
<tr>
  <td className="align-middle">Chengying</td>
  <td className="align-middle">Mao</td>
  <td className="align-middle">School of Software and IoT Engineering, Jiangxi University of Finance and Economics</td>
</tr>
<tr>
  <td className="align-middle">Chien-Sing</td>
  <td className="align-middle">Lee</td>
  <td className="align-middle"></td>
</tr>
<tr>
  <td className="align-middle">Colin G.</td>
  <td className="align-middle">Johnson</td>
  <td className="align-middle">University of Nottingham</td>
</tr>
<tr>
  <td className="align-middle">Diana Juniza</td>
  <td className="align-middle">Juanis</td>
  <td className="align-middle">UiTM</td>
</tr>
<tr>
  <td className="align-middle">Erfan</td>
  <td className="align-middle">Babaee Tirkolaee</td>
  <td className="align-middle">Department of Industrial Engineering, Istinye University</td>
</tr>
<tr>
  <td className="align-middle">Fernando</td>
  <td className="align-middle">Lezama</td>
  <td className="align-middle">GECAD-Polytechnic of Porto</td>
</tr>
<tr>
  <td className="align-middle">Germano</td>
  <td className="align-middle">Lambert-Torres</td>
  <td className="align-middle">PS Solutions</td>
</tr>
<tr>
  <td className="align-middle">Guo</td>
  <td className="align-middle">Yi-Nan</td>
  <td className="align-middle">China University of Mining and Technology</td>
</tr>
<tr>
  <td className="align-middle">Guoyin</td>
  <td className="align-middle">Wang</td>
  <td className="align-middle">Chongqing University of Posts and Telecommunications</td>
</tr>
<tr>
  <td className="align-middle">Hazrina Haja Bava</td>
  <td className="align-middle">Mohidin</td>
  <td className="align-middle">University of Malaya</td>
</tr>
<tr>
  <td className="align-middle">Hongyuan</td>
  <td className="align-middle">Gao</td>
  <td className="align-middle">Harbin Engineering University</td>
</tr>
<tr>
  <td className="align-middle">Isidoros</td>
  <td className="align-middle">Perikos</td>
  <td className="align-middle">University of Patras</td>
</tr>
<tr>
  <td className="align-middle">Jiacheng</td>
  <td className="align-middle">Li</td>
  <td className="align-middle">Kanagawa University</td>
</tr>
<tr>
  <td className="align-middle">Jianping</td>
  <td className="align-middle">Gou</td>
  <td className="align-middle">School of Computer Science and Telecommunication Engineering, JiangSu University</td>
</tr>
<tr>
  <td className="align-middle">Jie</td>
  <td className="align-middle">Zhang</td>
  <td className="align-middle">Newcastle University</td>
</tr>
<tr>
  <td className="align-middle">Ju</td>
  <td className="align-middle">Liu</td>
  <td className="align-middle">School of Information Science and Engineering, Shandong University</td>
</tr>
<tr>
  <td className="align-middle">Jun</td>
  <td className="align-middle">Yu</td>
  <td className="align-middle">Niigata University</td>
</tr>
<tr>
  <td className="align-middle">Junfeng</td>
  <td className="align-middle">Chen</td>
  <td className="align-middle">Hohai University</td>
</tr>
<tr>
  <td className="align-middle">Junru</td>
  <td className="align-middle">Zhu</td>
  <td className="align-middle">Amazon</td>
</tr>
<tr>
  <td className="align-middle">Khaldoon</td>
  <td className="align-middle">Dhou</td>
  <td className="align-middle">Texas A&M University Central Texas</td>
</tr>
<tr>
  <td className="align-middle">Lei</td>
  <td className="align-middle">Li</td>
  <td className="align-middle">Hosei University</td>
</tr>
<tr>
  <td className="align-middle">Li</td>
  <td className="align-middle">Xuesong</td>
  <td className="align-middle">Meiji University</td>
</tr>
<tr>
  <td className="align-middle">Liam</td>
  <td className="align-middle">Liu</td>
  <td className="align-middle">Zhejiang University</td>
</tr>
<tr>
  <td className="align-middle">Liang</td>
  <td className="align-middle">Wang</td>
  <td className="align-middle">Northwestern Polytechnical University</td>
</tr>
<tr>
  <td className="align-middle">Lu</td>
  <td className="align-middle">Han</td>
  <td className="align-middle">Central University of Finance and Economics</td>
</tr>
<tr>
  <td className="align-middle">Mario</td>
  <td className="align-middle">Pavone</td>
  <td className="align-middle">University of Catania</td>
</tr>
<tr>
  <td className="align-middle">Mayank</td>
  <td className="align-middle">Verma</td>
  <td className="align-middle">Delhi Technological University</td>
</tr>
<tr>
  <td className="align-middle">Mohit</td>
  <td className="align-middle">Tiwari</td>
  <td className="align-middle">Bharati Vidyapeeth&apos;s College of Engineering,Delhi</td>
</tr>
<tr>
  <td className="align-middle">Molla Rashied</td>
  <td className="align-middle">Hussein</td>
  <td className="align-middle">University of Asia Pacific</td>
</tr>
<tr>
  <td className="align-middle">Mubeen Tajudeen</td>
  <td className="align-middle">M</td>
  <td className="align-middle">TON DUC THANG UNIVERSITY VIETNAM</td>
</tr>
<tr>
  <td className="align-middle">Muhammad</td>
  <td className="align-middle">Aamir</td>
  <td className="align-middle">Huanggang Normal University</td>
</tr>
<tr>
  <td className="align-middle">Nadzirah</td>
  <td className="align-middle">Binti Zainordin</td>
  <td className="align-middle"></td>
</tr>
<tr>
  <td className="align-middle">Nurhanisah</td>
  <td className="align-middle">Mohdhawari</td>
  <td className="align-middle"></td>
</tr>
<tr>
  <td className="align-middle">Om Prakash</td>
  <td className="align-middle">Patel</td>
  <td className="align-middle">Mahindra University</td>
</tr>
<tr>
  <td className="align-middle">Patrick</td>
  <td className="align-middle">Siarry</td>
  <td className="align-middle"></td>
</tr>
<tr>
  <td className="align-middle">Patrick Sorrel</td>
  <td className="align-middle">Mvoto Kongo</td>
  <td className="align-middle">University of Yaoundé</td>
</tr>
<tr>
  <td className="align-middle">Peng-Yeng</td>
  <td className="align-middle">Yin</td>
  <td className="align-middle">National Chi Nan University</td>
</tr>
<tr>
  <td className="align-middle">Prof. Dr. Carsten</td>
  <td className="align-middle">Mueller</td>
  <td className="align-middle">Baden-Wuerttemberg Cooperative State University Mosbach</td>
</tr>
<tr>
  <td className="align-middle">Prof.O.P.</td>
  <td className="align-middle">Vyas</td>
  <td className="align-middle">Indian Institute of Information Technology Allahabad</td>
</tr>
<tr>
  <td className="align-middle">Qieshi</td>
  <td className="align-middle">Zhang</td>
  <td className="align-middle"></td>
</tr>
<tr>
  <td className="align-middle">Qingjian</td>
  <td className="align-middle">Ni</td>
  <td className="align-middle">Southeast University</td>
</tr>
<tr>
  <td className="align-middle">Qingxiong</td>
  <td className="align-middle">Tan</td>
  <td className="align-middle">Wuhan University</td>
</tr>
<tr>
  <td className="align-middle">Qiqi</td>
  <td className="align-middle">Duan</td>
  <td className="align-middle"></td>
</tr>
<tr>
  <td className="align-middle">Qiyuan</td>
  <td className="align-middle">Tian</td>
  <td className="align-middle">George Washington University</td>
</tr>
<tr>
  <td className="align-middle">Radu-Emil</td>
  <td className="align-middle">Precup</td>
  <td className="align-middle">Politehnica University of Timisoara</td>
</tr>
<tr>
  <td className="align-middle">Raoultdabou</td>
  <td className="align-middle">Teukam</td>
  <td className="align-middle"></td>
</tr>
<tr>
  <td className="align-middle">Ravi</td>
  <td className="align-middle">Malhotra</td>
  <td className="align-middle">Google</td>
</tr>
<tr>
  <td className="align-middle">Rodrigo</td>
  <td className="align-middle">Guido</td>
  <td className="align-middle">São Paulo State University</td>
</tr>
<tr>
  <td className="align-middle">Rui</td>
  <td className="align-middle">Xu</td>
  <td className="align-middle">Hohai University</td>
</tr>
<tr>
  <td className="align-middle">Rui</td>
  <td className="align-middle">Zhong</td>
  <td className="align-middle">Hokkaido University</td>
</tr>
<tr>
  <td className="align-middle">Sang-Heon</td>
  <td className="align-middle">Lee</td>
  <td className="align-middle"></td>
</tr>
<tr>
  <td className="align-middle">Seyyedali</td>
  <td className="align-middle">Hoseini</td>
  <td className="align-middle">University of Birjand</td>
</tr>
<tr>
  <td className="align-middle">Shad</td>
  <td className="align-middle">Kirmani</td>
  <td className="align-middle">LinkedIn Corporation</td>
</tr>
<tr>
  <td className="align-middle">Shi</td>
  <td className="align-middle">Cheng</td>
  <td className="align-middle">Shaanxi Normal University</td>
</tr>
<tr>
  <td className="align-middle">Souseelya</td>
  <td className="align-middle">Kidambi</td>
  <td className="align-middle"></td>
</tr>
<tr>
  <td className="align-middle">Sreeja</td>
  <td className="align-middle">N.K</td>
  <td className="align-middle">PSG College of Technology</td>
</tr>
<tr>
  <td className="align-middle">Srinivasa Rao</td>
  <td className="align-middle">Satti</td>
  <td className="align-middle">Norwegian University of Science and Technology</td>
</tr>
<tr>
  <td className="align-middle">Sudip</td>
  <td className="align-middle">Sahana</td>
  <td className="align-middle">B.I.T(Mesra), Ranchi.</td>
</tr>
<tr>
  <td className="align-middle">Tao</td>
  <td className="align-middle">Wang</td>
  <td className="align-middle">National University of Defense Technology</td>
</tr>
<tr>
  <td className="align-middle">Tapan</td>
  <td className="align-middle">Manaktala</td>
  <td className="align-middle">Meta Platforms Inc</td>
</tr>
<tr>
  <td className="align-middle">Tianwei</td>
  <td className="align-middle">Zhou</td>
  <td className="align-middle">Shenzhen University</td>
</tr>
<tr>
  <td className="align-middle">Tugrul</td>
  <td className="align-middle">Bayrak</td>
  <td className="align-middle"></td>
</tr>
<tr>
  <td className="align-middle">Wan Nur Syahidah</td>
  <td className="align-middle">Wan Yusoff</td>
  <td className="align-middle">UNIVERSITI MALAYSIA PAHANG</td>
</tr>
<tr>
  <td className="align-middle">MG</td>
  <td className="align-middle">Wang</td>
  <td className="align-middle"></td>
</tr>
<tr>
  <td className="align-middle">Wei</td>
  <td className="align-middle">Deng</td>
  <td className="align-middle">Southwestern University of Finance and Economics</td>
</tr>
<tr>
  <td className="align-middle">Wenjian</td>
  <td className="align-middle">Luo</td>
  <td className="align-middle">Harbin Institute of Technology</td>
</tr>
<tr>
  <td className="align-middle">Wenjing</td>
  <td className="align-middle">Hong</td>
  <td className="align-middle">Shenzhen University</td>
</tr>
<tr>
  <td className="align-middle">Xiangyin</td>
  <td className="align-middle">Zhang</td>
  <td className="align-middle">Beijing University of Technology</td>
</tr>
<tr>
  <td className="align-middle">Xinchao</td>
  <td className="align-middle">Zhao</td>
  <td className="align-middle">Beijing University of Posts and Telecommunications</td>
</tr>
<tr>
  <td className="align-middle">Xingxin</td>
  <td className="align-middle">Gu</td>
  <td className="align-middle">Northeastern University</td>
</tr>
<tr>
  <td className="align-middle">Xu</td>
  <td className="align-middle">Yan</td>
  <td className="align-middle">Trine University</td>
</tr>
<tr>
  <td className="align-middle">Yan</td>
  <td className="align-middle">Pei</td>
  <td className="align-middle">University of Aizu</td>
</tr>
<tr>
  <td className="align-middle">Yang</td>
  <td className="align-middle">Shen</td>
  <td className="align-middle">University of Technology Sydney</td>
</tr>
<tr>
  <td className="align-middle">Yang</td>
  <td className="align-middle">Cao</td>
  <td className="align-middle">Hokkaido University</td>
</tr>
<tr>
  <td className="align-middle">Yang</td>
  <td className="align-middle">Zhang</td>
  <td className="align-middle">Boston University</td>
</tr>
<tr>
  <td className="align-middle">Yi</td>
  <td className="align-middle">Liu</td>
  <td className="align-middle">Advanced Institute of Big Data</td>
</tr>
<tr>
  <td className="align-middle">Yichao</td>
  <td className="align-middle">Shi</td>
  <td className="align-middle">Georgia Institute of Technology</td>
</tr>
<tr>
  <td className="align-middle">Ying</td>
  <td className="align-middle">Tan</td>
  <td className="align-middle">Peking University</td>
</tr>
<tr>
  <td className="align-middle">Yingjie</td>
  <td className="align-middle">Yang</td>
  <td className="align-middle"></td>
</tr>
<tr>
  <td className="align-middle">Yong</td>
  <td className="align-middle">Zhao</td>
  <td className="align-middle">Sichuan University</td>
</tr>
<tr>
  <td className="align-middle">Yu</td>
  <td className="align-middle">Xue</td>
  <td className="align-middle">School of Computer and Software, Nanjing University of Information Science & Technology</td>
</tr>
<tr>
  <td className="align-middle">Yun</td>
  <td className="align-middle">Zhou</td>
  <td className="align-middle">National University of Defense Technology</td>
</tr>
<tr>
  <td className="align-middle">Shaoqiu</td>
  <td className="align-middle">Zheng</td>
  <td className="align-middle"></td>
</tr>
<tr>
  <td className="align-middle">Zhicong</td>
  <td className="align-middle">Liu</td>
  <td className="align-middle">Sun Yat-sen University</td>
</tr>
<tr>
  <td className="align-middle">Zhizhong</td>
  <td className="align-middle">Wu</td>
  <td className="align-middle">UC Berkeley</td>
</tr>
<tr>
  <td className="align-middle">Zhou</td>
  <td className="align-middle">Yu</td>
  <td className="align-middle">University of Illinois Chicago</td>
</tr>

            </tbody>
          </table>

          <p></p>

          <p></p>
        </div>
      </EmptyTwo>
      {/* <AboutFive />
            <TestimonialContainer classOption="bg-primary-blue" />
            <CallToActionTwo /> */}
      <Footer />
      <ScrollToTop />
    </React.Fragment>
  );
};

export default Committees;
